import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import { useStateValue } from "../Registration/Components/ContextAPI/StateProvider";
import { pointtochk, pointtochkobj } from "../plandata";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const PlanModal = ({
  plan,
  handledeviceplanchange,
  index,
  servicePlanGPS,
  servicerules,
}) => {
  const [planmodal, setplanmodal] = useState(false);
  const [plantab, setplantab] = useState("quarterly");

  // eslint-disable-next-line
  const [{ discount_quarter, discount_yearly }, dispatch] = useStateValue();

  const closeplanmodal = () => {
    setplanmodal(!planmodal);
    handleplan(plan);
  };
  const handleplan = (e, flag = false) => {
    let val = { target: { value: e } };
    handledeviceplanchange(val, index);
    if (flag) {
      setTimeout(() => {
        setplanmodal(!planmodal);
      }, 500);
    }
  };
  const getrupees = (planid) => {
    if (servicePlanGPS[planid]) {
      let price = servicePlanGPS[planid]["price"];
      let price2 = parseFloat(
        Number(price) / Number(servicePlanGPS[planid]["duration"])
      ).toFixed(2);
      price2 = price2.toString().split(".");
      return price2[0];
    }
    return "00";
  };
  const getpaisa = (planid) => {
    if (servicePlanGPS[planid]) {
      let price = servicePlanGPS[planid]["price"];
      let price2 = parseFloat(
        Number(price) / Number(servicePlanGPS[planid]["duration"])
      ).toFixed(2);
      price2 = price2.toString().split(".");
      return price2[1];
    }
    return "00";
  };
  const getbatterylife = (planid) => {
    if (servicePlanGPS[planid]) {
      let life = servicePlanGPS[planid]["plan_description"].split(":")[1];

      return life;
    }
    return "";
  };
  // const getrupees = (price) => {
  //   if (price && price.toString().split(".") && price.toString().split(".")[0])
  //     return price.toString().split(".")[0];
  //   return "00";
  // };
  // const getpaisa = (price) => {
  //   if (price && price.toString().split(".") && price.toString().split(".")[1])
  //     return price.toString().split(".")[1];
  //   return "00";
  // };
  const getclass = (val) => {
    let className = "planouterdiv";
    if (plan === val) {
      className = "planouterdiv active";
    }
    return className;
  };
  const getrecommendedclass = (val) => {
    let className = "plan_recommended";
    if (plan === val) {
      className = "plan_recommended active_recommended";
    }
    return className;
  };

  const getclassname = (type, planid) => {
    if (type === "coverage" || type === "reports") return "plandetail";
    if (servicerules[planid] && servicerules[planid]["rules"]) {
      if (servicerules[planid]["rules"].search(type) !== -1) {
        return "plandetail";
      } else {
        return "plandetail plandetaildisable";
      }
    }
    return "plandetail plandetaildisable";
  };
  const geticlassname = (type, planid) => {
    if (type === "coverage" || type === "reports") return "fa fa-check";
    if (servicerules[planid] && servicerules[planid]["rules"]) {
      if (servicerules[planid]["rules"].search(type) !== -1) {
        return "fa fa-check";
      } else {
        return "fa fa-minus";
      }
    }
    return "fa fa-minus";
  };
  const getplanvalue = (type, planid) => {
    if (pointtochkobj[type]["value"].search(":") === -1) {
      return pointtochkobj[type]["value"];
    }
    if (servicerules[planid] && servicerules[planid]["rules"]) {
      if (servicerules[planid]["rules"].search(type) !== -1) {
        let value = servicerules[planid]["rules"].split(type)[1].split(",")[0];
        let txt = pointtochkobj[type]["value"];
        let txt2 = txt.replace(":", value);
        if (type === "sms_alerts_") {
          if (
            planid === "standard_quarterly" ||
            planid === "plus_quarterly" ||
            planid === "pro_quarterly"
          ) {
            txt2 = txt2 + " Quarterly";
          } else if (
            planid === "standard_yearly" ||
            planid === "plus_yearly" ||
            planid === "pro_yearly"
          ) {
            txt2 = txt2 + " Yearly";
          }
        }
        return txt2;
      } else {
        let txt = pointtochkobj[type]["value"];
        let txt2 = txt.replace(":", "");
        return txt2;
      }
    }
    let txt = pointtochkobj[type]["value"];
    let txt2 = txt.replace(":", "");
    return txt2;
  };

  //----------------------->Showing Image in Toolpit<-----------------------------

  const renderTooltip = (props) => (
    <Tooltip id="plan-tooltip" {...props}>
      <div>
        <p className="mb-0">60 sec frequency - 10-14 days battery</p>
        <p className="mb-0">30 sec frequency - 7-8 days battery</p>
        <p className="mb-0">5 sec frequency - 2-3 days battery</p>
        <p className="mb-0">1 sec frequency - 8-16 hr battery</p>
      </div>
    </Tooltip>
  );
  const renderTooltip2 = (props) => (
    <Tooltip id="plan-tooltip" {...props}>
      <div>
        <p className="mb-0">60 sec frequency - 10-14 days battery</p>
        <p className="mb-0">30 sec frequency - 7-8 days battery</p>
        <p className="mb-0">5 sec frequency - 2-3 days battery</p>
      </div>
    </Tooltip>
  );

  return (
    <div className="w-100">
      <div onClick={closeplanmodal}>
        {servicePlanGPS?.[plan]?.["service_plan_name"] ? (
          <div style={{ position: "relative" }}>
            <input
              className="form-control"
              value={servicePlanGPS?.[plan]?.["email_content"]}
              readOnly={true}
              style={{ paddingRight: "33px" }}
            />
            <img
              src="./down-arrow.svg"
              className="input_arrow"
              alt="select_arrow"
            />
          </div>
        ) : (
          <div style={{ position: "relative" }}>
            <p
              className="form-control text-left cursor-pointer"
              onClick={closeplanmodal}
            >
              Select Plan
            </p>
            <img
              src="./down-arrow.svg"
              className="input_arrow"
              alt="select_arrow"
            />
          </div>
        )}
      </div>
      <Modal
        size="xl"
        show={planmodal}
        onHide={() => closeplanmodal()}
        backdrop="static"
        centered
        className="pricingplanmodalsize"
      >
        <Modal.Body className="py-0">
          <div className="p-2 planmodal">
            <Tab.Container
              id="left-tabs-example "
              activeKey={plantab}
              onSelect={(k) => setplantab(k)}
            >
              <Nav variant="pills" style={{ position: "relative" }}>
                <Nav.Item>
                  <Nav.Link eventKey="month">Monthly</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="quarterly">
                    Quarterly
                    <span className="pricing_discountspan">
                      SAVE upto {discount_quarter}%
                    </span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="yearly">
                    Yearly{" "}
                    <span className="pricing_discountspan">
                      SAVE upto {discount_yearly}%
                    </span>
                  </Nav.Link>
                </Nav.Item>
                <div className="absolutesave">
                  <button
                    onClick={() => closeplanmodal()}
                    className="planselectbutton"
                  >
                    Select
                  </button>
                  <button
                    onClick={() => closeplanmodal()}
                    className="btn btn-danger ml-2"
                  >
                    Close
                  </button>
                </div>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="month">
                  <div>
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          className={getclass("standard")}
                          onClick={() => handleplan("standard")}
                        >
                          <span className="plancheckmark"></span>
                          <h4>Standard</h4>
                          <div className="planmodalheaderdiv">
                            <p className="planmodalheader">
                              <span>upto</span>
                              <span>30</span> <span>sec</span>
                              <span>reporting</span>
                            </p>
                          </div>
                          <p className="planmodalpricing">
                            <span>
                              $ {getrupees("standard")}
                              <sup>{getpaisa("standard")}</sup>
                            </span>
                            /month
                          </p>
                          {/* <h5>Billed Monthly</h5> */}
                          <h5 className="batterylife">
                            {getbatterylife("standard")}
                          </h5>
                          <h5 className="batterylife font-weight-bold text-dark">
                            Total Billed - $
                            {servicePlanGPS?.["standard"]?.price}
                          </h5>
                          <hr />
                          {pointtochk.map((item, i) => (
                            <div key={i}>
                              <div
                                className={getclassname(item.key, "standard")}
                              >
                                <i
                                  className={geticlassname(
                                    item.key,
                                    "standard"
                                  )}
                                  aria-hidden="true"
                                ></i>
                                <p>{getplanvalue(item.key, "standard")}</p>
                              </div>
                            </div>
                          ))}
                          <hr />
                          <div className="planselectbtndiv">
                            <button
                              className="planselectbutton"
                              onClick={() => handleplan("standard", true)}
                            >
                              Select & Save
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className={getrecommendedclass("plus")}>
                          <p className="mb-0">RECOMMENDED</p>
                        </div>
                        <div
                          className={getclass("plus")}
                          onClick={() => handleplan("plus")}
                          style={{ border: "2px solid rgb(30, 57, 140)" }}
                        >
                          <span className="plancheckmark"></span>
                          <h4>Plus</h4>
                          <div className="planmodalheaderdiv">
                            <p className="planmodalheader">
                              <span>upto</span>
                              <span>5</span> <span>sec</span>
                              <span>reporting</span>
                            </p>
                          </div>
                          <p className="planmodalpricing">
                            <span>
                              $ {getrupees("plus")}
                              <sup>{getpaisa("plus")}</sup>
                            </span>
                            /month
                          </p>
                          {/* <h5>Billed Monthly</h5> */}
                          <OverlayTrigger
                            delay={{ show: 100, hide: 250 }}
                            overlay={renderTooltip2}
                          >
                            <h5 className="batterylife">
                              Battery Life{" "}
                              <i
                                class="fa fa-info-circle"
                                aria-hidden="true"
                              ></i>
                            </h5>
                          </OverlayTrigger>
                          <h5 className="batterylife font-weight-bold text-dark">
                            Total Billed - ${servicePlanGPS?.["plus"]?.price}
                          </h5>
                          <hr />
                          {pointtochk.map((item, i) => (
                            <div key={i}>
                              <div className={getclassname(item.key, "plus")}>
                                <i
                                  className={geticlassname(item.key, "plus")}
                                  aria-hidden="true"
                                ></i>
                                <p>{getplanvalue(item.key, "plus")}</p>
                              </div>
                            </div>
                          ))}
                          <hr />
                          <div className="planselectbtndiv">
                            <button
                              className="planselectbutton"
                              onClick={() => handleplan("plus", true)}
                            >
                              Select & Save
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div
                          className={getclass("pro")}
                          onClick={() => handleplan("pro")}
                        >
                          <span className="plancheckmark"></span>
                          <h4>Pro</h4>
                          <div className="planmodalheaderdiv">
                            <p className="planmodalheader">
                              <span>upto</span>
                              <span>1</span> <span>sec</span>
                              <span>reporting</span>
                            </p>
                          </div>
                          <p className="planmodalpricing">
                            <span>
                              $ {getrupees("pro")}
                              <sup>{getpaisa("pro")}</sup>
                            </span>
                            /month
                          </p>
                          {/* <h5>Billed Monthly</h5> */}
                          <OverlayTrigger
                            delay={{ show: 100, hide: 250 }}
                            overlay={renderTooltip}
                          >
                            <h5 className="batterylife">
                              Battery Life{" "}
                              <i
                                class="fa fa-info-circle"
                                aria-hidden="true"
                              ></i>
                            </h5>
                          </OverlayTrigger>
                          <h5 className="batterylife font-weight-bold text-dark">
                            Total Billed - ${servicePlanGPS?.["pro"]?.price}
                          </h5>
                          <hr />
                          {pointtochk.map((item, i) => (
                            <div key={i}>
                              <div className={getclassname(item.key, "pro")}>
                                <i
                                  className={geticlassname(item.key, "pro")}
                                  aria-hidden="true"
                                ></i>
                                <p>{getplanvalue(item.key, "pro")}</p>
                              </div>
                            </div>
                          ))}
                          <hr />
                          <div className="planselectbtndiv">
                            <button
                              className="planselectbutton"
                              onClick={() => handleplan("pro", true)}
                            >
                              Select & Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="quarterly">
                  <div>
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          className={getclass("standard_quarterly")}
                          onClick={() => handleplan("standard_quarterly")}
                        >
                          <span className="plancheckmark"></span>
                          <h4>Standard</h4>
                          <div className="planmodalheaderdiv">
                            <p className="planmodalheader">
                              <span>upto</span>
                              <span>30</span> <span>sec</span>
                              <span>reporting</span>
                            </p>
                          </div>
                          <p className="planmodalpricing">
                            <span>
                              $ {getrupees("standard_quarterly")}
                              <sup>{getpaisa("standard_quarterly")}</sup>
                            </span>
                            /month
                          </p>
                          <h5>Billed Quarterly</h5>
                          <h5 className="batterylife">
                            {getbatterylife("standard_quarterly")}
                          </h5>
                          <h5 className="batterylife font-weight-bold text-dark">
                            Total Billed - $
                            {servicePlanGPS?.["standard_quarterly"]?.price}
                          </h5>
                          <hr />
                          {pointtochk.map((item, i) => (
                            <div key={i}>
                              <div
                                className={getclassname(
                                  item.key,
                                  "standard_quarterly"
                                )}
                              >
                                <i
                                  className={geticlassname(
                                    item.key,
                                    "standard_quarterly"
                                  )}
                                  aria-hidden="true"
                                ></i>
                                <p>
                                  {getplanvalue(item.key, "standard_quarterly")}
                                </p>
                              </div>
                            </div>
                          ))}
                          <hr />
                          <div className="planselectbtndiv">
                            <button
                              className="planselectbutton"
                              onClick={() =>
                                handleplan("standard_quarterly", true)
                              }
                            >
                              Select & Save
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className={getrecommendedclass("plus_quarterly")}>
                          <p className="mb-0">RECOMMENDED</p>
                        </div>
                        <div
                          className={getclass("plus_quarterly")}
                          onClick={() => handleplan("plus_quarterly")}
                          style={{ border: "2px solid rgb(30, 57, 140)" }}
                        >
                          <span className="plancheckmark"></span>
                          <h4>Plus</h4>
                          <div className="planmodalheaderdiv">
                            <p className="planmodalheader">
                              <span>upto</span>
                              <span>5</span> <span>sec</span>
                              <span>reporting</span>
                            </p>
                          </div>
                          <p className="planmodalpricing">
                            <span>
                              $ {getrupees("plus_quarterly")}
                              <sup>{getpaisa("plus_quarterly")}</sup>
                            </span>
                            /month
                          </p>
                          <h5>Billed Quarterly</h5>
                          <OverlayTrigger
                            delay={{ show: 100, hide: 250 }}
                            overlay={renderTooltip2}
                          >
                            <h5 className="batterylife">
                              Battery Life{" "}
                              <i
                                class="fa fa-info-circle"
                                aria-hidden="true"
                              ></i>
                            </h5>
                          </OverlayTrigger>
                          <h5 className="batterylife font-weight-bold text-dark">
                            Total Billed - $
                            {servicePlanGPS?.["plus_quarterly"]?.price}
                          </h5>
                          <hr />
                          {pointtochk.map((item, i) => (
                            <div key={i}>
                              <div
                                className={getclassname(
                                  item.key,
                                  "plus_quarterly"
                                )}
                              >
                                <i
                                  className={geticlassname(
                                    item.key,
                                    "plus_quarterly"
                                  )}
                                  aria-hidden="true"
                                ></i>
                                <p>
                                  {getplanvalue(item.key, "plus_quarterly")}
                                </p>
                              </div>
                            </div>
                          ))}
                          <hr />
                          <div className="planselectbtndiv">
                            <button
                              className="planselectbutton"
                              onClick={() => handleplan("plus_quarterly", true)}
                            >
                              Select & Save
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div
                          className={getclass("pro_quarterly")}
                          onClick={() => handleplan("pro_quarterly")}
                        >
                          <span className="plancheckmark"></span>
                          <h4>Pro</h4>
                          <div className="planmodalheaderdiv">
                            <p className="planmodalheader">
                              <span>upto</span>
                              <span>1</span> <span>sec</span>
                              <span>reporting</span>
                            </p>
                          </div>
                          <p className="planmodalpricing">
                            <span>
                              $ {getrupees("pro_quarterly")}
                              <sup>{getpaisa("pro_quarterly")}</sup>
                            </span>
                            /month
                          </p>
                          <h5>Billed Quarterly</h5>
                          <OverlayTrigger
                            delay={{ show: 100, hide: 250 }}
                            overlay={renderTooltip}
                          >
                            <h5 className="batterylife">
                              Battery Life{" "}
                              <i
                                class="fa fa-info-circle"
                                aria-hidden="true"
                              ></i>
                            </h5>
                          </OverlayTrigger>
                          <h5 className="batterylife font-weight-bold text-dark">
                            Total Billed - $
                            {servicePlanGPS?.["pro_quarterly"]?.price}
                          </h5>
                          <hr />
                          {pointtochk.map((item, i) => (
                            <div key={i}>
                              <div
                                className={getclassname(
                                  item.key,
                                  "pro_quarterly"
                                )}
                              >
                                <i
                                  className={geticlassname(
                                    item.key,
                                    "pro_quarterly"
                                  )}
                                  aria-hidden="true"
                                ></i>
                                <p>{getplanvalue(item.key, "pro_quarterly")}</p>
                              </div>
                            </div>
                          ))}
                          <hr />
                          <div className="planselectbtndiv">
                            <button
                              className="planselectbutton"
                              onClick={() => handleplan("pro_quarterly", true)}
                            >
                              Select & Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="yearly">
                  <div>
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          className={getclass("standard_yearly")}
                          onClick={() => handleplan("standard_yearly")}
                        >
                          <span className="plancheckmark"></span>
                          <h4>Standard</h4>
                          <div className="planmodalheaderdiv">
                            <p className="planmodalheader">
                              <span>upto</span>
                              <span>30</span> <span>sec</span>
                              <span>reporting</span>
                            </p>
                          </div>
                          <p className="planmodalpricing">
                            <span>
                              $ {getrupees("standard_yearly")}
                              <sup>{getpaisa("standard_yearly")}</sup>
                            </span>
                            /month
                          </p>
                          <h5>Billed Yearly</h5>
                          <h5 className="batterylife">
                            {getbatterylife("standard_yearly")}
                          </h5>
                          <h5 className="batterylife font-weight-bold text-dark">
                            Total Billed - $
                            {servicePlanGPS?.["standard_yearly"]?.price}
                          </h5>
                          <hr />
                          {pointtochk.map((item, i) => (
                            <div key={i}>
                              <div
                                className={getclassname(
                                  item.key,
                                  "standard_yearly"
                                )}
                              >
                                <i
                                  className={geticlassname(
                                    item.key,
                                    "standard_yearly"
                                  )}
                                  aria-hidden="true"
                                ></i>
                                <p>
                                  {getplanvalue(item.key, "standard_yearly")}
                                </p>
                              </div>
                            </div>
                          ))}
                          <hr />
                          <div className="planselectbtndiv">
                            <button
                              className="planselectbutton"
                              onClick={() =>
                                handleplan("standard_yearly", true)
                              }
                            >
                              Select & Save
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className={getrecommendedclass("plus_yearly")}>
                          <p className="mb-0">RECOMMENDED</p>
                        </div>
                        <div
                          className={getclass("plus_yearly")}
                          onClick={() => handleplan("plus_yearly")}
                          style={{ border: "2px solid rgb(30, 57, 140)" }}
                        >
                          <span className="plancheckmark"></span>
                          <h4>Plus</h4>
                          <div className="planmodalheaderdiv">
                            <p className="planmodalheader">
                              <span>upto</span>
                              <span>5</span> <span>sec</span>
                              <span>reporting</span>
                            </p>
                          </div>
                          <p className="planmodalpricing">
                            <span>
                              $ {getrupees("plus_yearly")}
                              <sup>{getpaisa("plus_yearly")}</sup>
                            </span>
                            /month
                          </p>
                          <h5>Billed Yearly</h5>
                          <OverlayTrigger
                            delay={{ show: 100, hide: 250 }}
                            overlay={renderTooltip2}
                          >
                            <h5 className="batterylife">
                              Battery Life{" "}
                              <i
                                class="fa fa-info-circle"
                                aria-hidden="true"
                              ></i>
                            </h5>
                          </OverlayTrigger>
                          <h5 className="batterylife font-weight-bold text-dark">
                            Total Billed - $
                            {servicePlanGPS?.["plus_yearly"]?.price}
                          </h5>
                          <hr />
                          {pointtochk.map((item, i) => (
                            <div key={i}>
                              <div
                                className={getclassname(
                                  item.key,
                                  "plus_yearly"
                                )}
                              >
                                <i
                                  className={geticlassname(
                                    item.key,
                                    "plus_yearly"
                                  )}
                                  aria-hidden="true"
                                ></i>
                                <p>{getplanvalue(item.key, "plus_yearly")}</p>
                              </div>
                            </div>
                          ))}
                          <hr />
                          <div className="planselectbtndiv">
                            <button
                              className="planselectbutton"
                              onClick={() => handleplan("plus_yearly", true)}
                            >
                              Select & Save
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div
                          className={getclass("pro_yearly")}
                          onClick={() => handleplan("pro_yearly")}
                        >
                          <span className="plancheckmark"></span>
                          <h4>Pro</h4>
                          <div className="planmodalheaderdiv">
                            <p className="planmodalheader">
                              <span>upto</span>
                              <span>1</span> <span>sec</span>
                              <span>reporting</span>
                            </p>
                          </div>
                          <p className="planmodalpricing">
                            <span>
                              $ {getrupees("pro_yearly")}
                              <sup>{getpaisa("pro_yearly")}</sup>
                            </span>
                            /month
                          </p>
                          <h5>Billed Yearly</h5>
                          <OverlayTrigger
                            delay={{ show: 100, hide: 250 }}
                            overlay={renderTooltip}
                          >
                            <h5 className="batterylife">
                              Battery Life{" "}
                              <i
                                class="fa fa-info-circle"
                                aria-hidden="true"
                              ></i>
                            </h5>
                          </OverlayTrigger>
                          <h5 className="batterylife font-weight-bold text-dark">
                            Total Billed - $
                            {servicePlanGPS?.["pro_yearly"]?.price}
                          </h5>
                          <hr />
                          {pointtochk.map((item, i) => (
                            <div key={i}>
                              <div
                                className={getclassname(item.key, "pro_yearly")}
                              >
                                <i
                                  className={geticlassname(
                                    item.key,
                                    "pro_yearly"
                                  )}
                                  aria-hidden="true"
                                ></i>
                                <p>{getplanvalue(item.key, "pro_yearly")}</p>
                              </div>
                            </div>
                          ))}
                          <hr />
                          <div className="planselectbtndiv">
                            <button
                              className="planselectbutton"
                              onClick={() => handleplan("pro_yearly", true)}
                            >
                              Select & Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div style={{ display: "flex" }}>
            <button
              onClick={() => closeplanmodal()}
              className="planselectbutton"
            >
              Select
            </button>
            <button
              onClick={() => closeplanmodal()}
              className="btn btn-danger ml-2"
            >
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PlanModal;
